
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Ce vaccin a été autorisé pour une utilisation urgente le 2 décembre par la
Grande-Bretagne, une première pour les pays occidentaux. Selon le “New York
Times”, les deux compagnies prévoient de produire trois milliards de doses dans
le monde entier d’ici fin 2021. Et Pfizer, qui présentait ses résultats
semestriels le 2 février, estime que ces ventes atteindront 15 milliards de
dollars.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;